import * as JsSearch from 'js-search';

export default function TabledPapersScript() {
    // Check if the module exists before doing anything
    const TabledPapersExists = !!document.querySelector('.tabled-papers');

    // If the module exists, do whatever we need to
    if (TabledPapersExists) {
        const dataEl = document.getElementById('tabled-papers-info');

        if (dataEl) {
            console.log('tabled papers script');

            const loader = document.querySelector('.tabled-papers__load');
            const warning = document.querySelector('.tabled-papers__warning');

            const dataFetch = async () => {
                const { url, fallbackUrl } = dataEl.dataset;
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        warning.style.display = 'block';
                        const fallbackRes = await fetch(fallbackUrl);
                        const fallbackData = await fallbackRes.json();
                        return fallbackData;
                    }
                    const data = await response.json();

                    loader.style.display = 'none';

                    return data;
                } catch (error) {
                    console.error('Error fetching data:', error);
                    warning.style.display = 'block';
                    const fallbackRes = await fetch(fallbackUrl);
                    const fallbackData = await fallbackRes.json();
                    loader.style.display = 'none';
                    return fallbackData;
                }
            };

            const dataYear = dataEl.dataset.year;
            const pageUrl = dataEl.dataset.feUrl;

            const bringResults = dataFetch().then((data) => { // eslint-disable-line
                // console.log(data);

                // Format the dates
                const papers = data.data.map((paper) => {
                    const dateFormat = paper.date.split('/');
                    const newDate = `${dateFormat[2]}-${dateFormat[1]}-${dateFormat[0]}`;
                    return { ...paper, date: newDate };
                });

                // console.log('papers data', papers);

                // reverse papers
                papers.reverse();

                let searchType;

                // Create the JS Search
                let search;

                // Change the search params depending on the object data
                if (papers[0].hasOwnProperty('number')) { // eslint-disable-line
                    console.log('has num');
                    search = new JsSearch.Search('number');
                    search.addIndex('date');
                    search.addIndex('description');
                    search.addDocuments(papers);

                    searchType = 'noLinks';
                } else if (papers[0].hasOwnProperty('url')) { // eslint-disable-line
                    search = new JsSearch.Search('url');
                    search.addIndex('date');
                    search.addIndex('description');
                    search.addDocuments(papers);

                    searchType = 'withLinks';

                    // console.log(search.search("1999-04"));
                }

                // Selectors
                const keywordInput = document.querySelector('.keyword-input');
                const submitButton = document.querySelector(
                    '.search-submit__btn'
                );
                const resetButton =
                    document.querySelector('.search-reset__btn');
                const daySelect = document.getElementById('day-select');
                const monthSelect = document.getElementById('month-select');

                const displayDataRows = (arr) => {
                    return arr
                        .map((item) => {
                            const dateFormat = item.date.split('-');
                            const newDate = `${dateFormat[2]}/${dateFormat[1]}/${dataYear}`;
                            const lastCol =
                                searchType === 'withLinks'
                                    ? `<a href="${pageUrl}${item.url}" target="_blank">View paper</a>`
                                    : item.number;
                            return `<tr><td>${newDate}</td><td>${item.description}</td><td>${lastCol}</td></tr>`;
                        })
                        .join('');
                };

                // Default results
                // let searchData = displayDataRows(papers);

                const populateTable = (text, tableData) => {
                    if (tableData === '') {
                        document.querySelector('#app').innerHTML = `${text}`;
                    } else {
                        const lastCol =
                            searchType === 'withLinks'
                                ? 'Paper link'
                                : 'Paper number';
                        document.querySelector('#app').innerHTML = `
                            ${text}
                            <table class="table--striped  table--head-palette-a">
                                <thead>
                                    <tr>
                                        <th>Date tabled</th>
                                        <th>Paper description</th>
                                        <th>${lastCol}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${tableData}
                                </tbody>
                            </table>
                        `;
                    }
                };

                populateTable(`<p>All results</p>`, displayDataRows(papers));

                // Event listeners: on click search button
                submitButton.addEventListener('click', (e) => {
                    e.preventDefault();

                    // No input
                    if (
                        keywordInput.value === '' &&
                        `${dataYear}-${monthSelect.value}-${daySelect.value}` ===
                            `${dataYear}--`
                    ) {
                        populateTable(
                            `<h3>All papers</h3>`,
                            displayDataRows(papers)
                        );
                    }

                    // keyword only
                    if (
                        keywordInput.value !== '' &&
                        `${dataYear}-${monthSelect.value}-${daySelect.value}` ===
                            `${dataYear}--`
                    ) {
                        // console.log('keyword only');
                        const resultKeyword = search.search(
                            `${keywordInput.value}`
                        );

                        // console.log(resultKeyword);

                        const resultText =
                            resultKeyword.length > 0
                                ? `<h3>Results for keyword: "<strong>${keywordInput.value}</strong>"</h3>`
                                : `<h3>No result for keyword: "<strong>${keywordInput.value}</strong>"</h3>`;

                        populateTable(
                            resultText,
                            displayDataRows(resultKeyword)
                        );
                    }

                    // Date only
                    else if (
                        `${dataYear}-${monthSelect.value}-${daySelect.value}` !==
                            `${dataYear}--` &&
                        keywordInput.value === ''
                    ) {
                        // console.log('date only');
                        console.log(
                            `${dataYear}-${monthSelect.value}-${daySelect.value}`
                        );

                        const resultDate = search.search(
                            `${dataYear}-${monthSelect.value}-${daySelect.value}`
                        );

                        // console.log(resultDate);

                        const dayText =
                            daySelect.value && `${daySelect.value}/`;
                        const monthText = monthSelect.value
                            ? `${monthSelect.value}/`
                            : '--/';

                        const resultText =
                            resultDate.length > 0
                                ? `<h3>Results for date: "<strong>${dayText}${monthText}${dataYear}</strong>"</h3>`
                                : `<h3>No result for date: "<strong>${dayText}${monthText}${dataYear}</strong>"</h3>`;

                        populateTable(resultText, displayDataRows(resultDate));
                    }

                    // Date and keyword
                    else if (
                        `${dataYear}-${monthSelect.value}-${daySelect.value}` !==
                            `${dataYear}--` &&
                        keywordInput.value !== ''
                    ) {
                        // console.log('Date and keyword');

                        const resultKeyword = search.search(
                            `${keywordInput.value}`
                        );
                        console.log(resultKeyword);

                        const resultDate = search.search(
                            `${dataYear}-${monthSelect.value}-${daySelect.value}`
                        );
                        // console.log(resultDate);

                        // Remove the duplicates
                        const combinedArr = [...resultKeyword, ...resultDate];

                        function findDuplicates(arr) { // eslint-disable-line
                            const duplicates = [];

                            arr.forEach((obj, index) => {
                                // Use slice to compare current object to remaining objects in array
                                const remainingObjs = arr.slice(index + 1);

                                remainingObjs.forEach((remainingObj) => {
                                    if (
                                        JSON.stringify(obj) ===
                                        JSON.stringify(remainingObj)
                                    ) {
                                        // If the objects are the same, add to duplicates array
                                        if (!duplicates.includes(obj)) {
                                            duplicates.push(obj);
                                        }
                                        if (
                                            !duplicates.includes(remainingObj)
                                        ) {
                                            duplicates.push(remainingObj);
                                        }
                                    }
                                });
                            });

                            return duplicates;
                        }

                        const filteredArr = findDuplicates(combinedArr);

                        const dayText =
                            daySelect.value && `${daySelect.value}/`;
                        const monthText = monthSelect.value
                            ? `${monthSelect.value}/`
                            : '--/';

                        const resultText =
                            filteredArr.length > 0
                                ? `<h3>Results for keyword "<strong>${keywordInput.value}</strong>" at the date of: "<strong>${dayText}${monthText}${dataYear}</strong>"</h3>`
                                : `<h3>No result for keyword "<strong>${keywordInput.value}</strong>" at the date of: "<strong>${dayText}${monthText}${dataYear}</strong>"</h3>`;

                        populateTable(resultText, displayDataRows(filteredArr));
                    }
                });

                resetButton.addEventListener('click', () => {
                    populateTable(
                        `<h3>All papers</h3>`,
                        displayDataRows(papers)
                    );
                    keywordInput.value === ''; // eslint-disable-line
                    monthSelect.value === ''; // eslint-disable-line
                    daySelect.value === ''; // eslint-disable-line
                });
            });
        }
    }
}

TabledPapersScript();
